import React, {createContext, useCallback, useContext, useEffect, useState} from "react";
import {LoginResultType, useGetMeQuery, UserType} from "../generated/graphql";
import {createClient} from "urql";

const UserLoginContext = createContext<any>(null);
const UserDataContext = createContext<LoginResultType|null>(null);

export function useUserLoginContext() {
    return useContext(UserLoginContext);
}
export function useUserDataContext(): LoginResultType|null {
    return useContext(UserDataContext);
}

type UserContextProps = React.PropsWithChildren<{}>;


export function UserContextProvider({children}: UserContextProps) {
    const [user,setUser] = useState<LoginResultType|null>(null);
    const token = window.localStorage.getItem('token');
    const [me] = useGetMeQuery({variables:{token:token??''},pause:!!user || !token});
    const doSetUser = useCallback((v:LoginResultType)=>{
        setUser(v);
       if(v) {
           window.localStorage.setItem('token',v.token??'');
       } else {
           window.localStorage.removeItem('token');
       }
    },[]);
    useEffect(()=>{
       if(me.data) {
           setUser(me?.data?.getMe??null);
       }
    },[me.data]);

    return <UserLoginContext.Provider value={doSetUser}>
        <UserDataContext.Provider value={user}>
            {children}
        </UserDataContext.Provider>
    </UserLoginContext.Provider>
}